import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getRecoveryRedirectTarget } from "@/lib/authRedirects";

/**
 * Catches Supabase password-recovery links that may land on ANY route
 * (e.g. "/" with #access_token=...&type=recovery, or "/?code=...").
 * Forwards them to /reset-password with the token info preserved so the
 * recovery page can establish a session and let the user set a new password.
 *
 * Why this is needed:
 * - Supabase auth emails redirect to `redirectTo` we pass, but if a user
 *   has an old link, or providers strip query params, the link can land on
 *   the homepage. Without this handler the hash session would be silently
 *   consumed by supabase-js and the user would just appear "logged in".
 */
const RecoveryLinkHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const target = getRecoveryRedirectTarget({
      pathname: location.pathname,
      search: window.location.search || location.search,
      hash: window.location.hash || location.hash,
    });
    if (target) navigate(target, { replace: true });
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
};

export default RecoveryLinkHandler;
